<div class="jw-modal" (contextmenu)="onRightClick($event)">
    <div class="{{style}}">
        <ng-content>

        </ng-content>
    </div>
</div>
<div class="jw-modal-background" (contextmenu)="onRightClick($event)"></div>